"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
const _ = __importStar(require("lodash"));
const vue_property_decorator_1 = require("vue-property-decorator");
const vue_class_component_1 = require("vue-class-component");
const core_1 = require("@integro/core");
let CreateTemplate = class CreateTemplate extends (0, vue_class_component_1.mixins)(core_1.UserComponentMixin) {
    componentMetadata = {
        kind: "page",
    };
    beforeCreate() {
    }
    size;
    onSize(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("size");
    }
    formId;
    async $$load_formId() {
        return this.$fn.randomElementId();
    }
    formName;
    item;
    async $$load_item() {
        return this.$fn.schemaDefaults('CreateTemplate');
    }
    objectTypes;
    async $$load_objectTypes() {
        return this.$fn.getEnumValuesFromSchema('ObjectTypes');
    }
    templateTypes;
    async $$load_templateTypes() {
        return this.$fn.getEnumValuesFromSchema('TemplateTypes');
    }
    ux;
    b_7315092382398562_modalBindings;
    dataMembers = ['formId', 'formName', 'item', 'objectTypes', 'templateTypes', 'ux', 'b_7315092382398562_modalBindings'];
    data() {
        return {
            ...this.mixinData(),
            actions: this.getActions(),
            ...{
                formId: null,
                formName: "template",
                item: null,
                objectTypes: null,
                templateTypes: null,
                ux: null,
                b_7315092382398562_modalBindings: {
                    size: "sm",
                },
            },
        };
    }
    get document() {
        if (this.loaded) {
            return {
                title: this.$fn.pgettext("Templates", "Create Template"),
            };
        }
        return null;
    }
    async act_7315092382398562_closeModal_4822_getActionArgs($event) {
        return {
            name: this.modalName,
            result: {
                close: true,
                cancel: true,
            },
        };
    }
    async evh_7315092382398562_close(event, scope) {
        return await this.actions.evh_7315092382398562_close.executeFromDOM(this, event, scope);
    }
    async evh_2248226175642056_close(event, scope) {
        return await this.actions.evh_2248226175642056_close.executeFromDOM(this, event, scope);
    }
    async act_1040167445267876_closeModal_4828_getActionArgs($event) {
        return {
            name: this.modalName,
            result: {
                close: true,
                value: $event.data.response.data,
            },
        };
    }
    async evh_1040167445267876_success_4827_getWhen($event) {
        return !!this.modalName;
    }
    async act_1040167445267876_request_4826_getActionArgs($event) {
        return {
            operation: "create_template",
            data: { ...this.item, content: '<div></div>' },
        };
    }
    async evh_1040167445267876_submit(event, scope) {
        return await this.actions.evh_1040167445267876_submit.executeFromDOM(this, event, scope);
    }
    async evh_1419464017721962_clickPreventStop(event, scope) {
        return await this.actions.evh_1419464017721962_clickPreventStop.executeFromDOM(this, event, scope);
    }
    actions;
    getActions() {
        const act_7315092382398562_closeModal_4822 = new core_1.actions.CloseModalAction({
            actionArgs: this.act_7315092382398562_closeModal_4822_getActionArgs,
            events: [],
        });
        const evh_7315092382398562_close_4821 = new core_1.actions.EventHandlerImpl({
            action: act_7315092382398562_closeModal_4822,
            event: "close",
            displayName: "closeModal",
        });
        const evh_7315092382398562_close = new core_1.actions.EventHandlerGroup({
            handlers: [evh_7315092382398562_close_4821],
        });
        const act_2248226175642056_closeComponent_4824 = new core_1.actions.CloseComponentAction({
            events: [],
        });
        const evh_2248226175642056_close_4823 = new core_1.actions.EventHandlerImpl({
            action: act_2248226175642056_closeComponent_4824,
            event: "close",
            displayName: "closeComponent",
        });
        const evh_2248226175642056_close = new core_1.actions.EventHandlerGroup({
            handlers: [evh_2248226175642056_close_4823],
        });
        const act_1040167445267876_closeModal_4828 = new core_1.actions.CloseModalAction({
            actionArgs: this.act_1040167445267876_closeModal_4828_getActionArgs,
            events: [],
        });
        const evh_1040167445267876_success_4827 = new core_1.actions.EventHandlerImpl({
            action: act_1040167445267876_closeModal_4828,
            event: "success",
            when: this.evh_1040167445267876_success_4827_getWhen,
            displayName: "closeModal",
        });
        const act_1040167445267876_request_4826 = new core_1.actions.RequestAction({
            actionArgs: this.act_1040167445267876_request_4826_getActionArgs,
            displayName: "submit",
            events: [evh_1040167445267876_success_4827],
        });
        const evh_1040167445267876_submit_4825 = new core_1.actions.EventHandlerImpl({
            action: act_1040167445267876_request_4826,
            event: "submit",
            displayName: "submit",
        });
        const evh_1040167445267876_submit = new core_1.actions.EventHandlerGroup({
            handlers: [evh_1040167445267876_submit_4825],
        });
        const act_1419464017721962_closeModal_4830 = new core_1.actions.CloseModalAction({
            events: [],
        });
        const evh_1419464017721962_clickPreventStop_4829 = new core_1.actions.EventHandlerImpl({
            action: act_1419464017721962_closeModal_4830,
            event: "click.prevent.stop",
            displayName: "closeModal",
        });
        const evh_1419464017721962_clickPreventStop = new core_1.actions.EventHandlerGroup({
            handlers: [evh_1419464017721962_clickPreventStop_4829],
        });
        return {
            act_7315092382398562_closeModal_4822,
            evh_7315092382398562_close_4821,
            evh_7315092382398562_close,
            act_2248226175642056_closeComponent_4824,
            evh_2248226175642056_close_4823,
            evh_2248226175642056_close,
            act_1040167445267876_closeModal_4828,
            evh_1040167445267876_success_4827,
            act_1040167445267876_request_4826,
            evh_1040167445267876_submit_4825,
            evh_1040167445267876_submit,
            act_1419464017721962_closeModal_4830,
            evh_1419464017721962_clickPreventStop_4829,
            evh_1419464017721962_clickPreventStop,
            submit: act_1040167445267876_request_4826,
        };
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
        default: "sm",
    }),
    __metadata("design:type", String)
], CreateTemplate.prototype, "size", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('size'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], CreateTemplate.prototype, "onSize", null);
CreateTemplate = __decorate([
    (0, vue_property_decorator_1.Component)()
], CreateTemplate);
exports.default = CreateTemplate;
vue_property_decorator_1.Vue.component("CreateTemplate", CreateTemplate);
